import { useEffect, useState } from 'react';

import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
// import { withStyles, makeStyles } from '@mui/material/styles';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

// const StyledTableCell = styled((theme) => ({
//   head: {
//     backgroundColor: theme.palette.common.black,
//     color: theme.palette.common.white,
//   },
//   body: {
//     fontSize: 14,
//   },
// }))(TableCell);

// const StyledTableRow = styled((theme) => ({
//   root: {
//     '&:nth-of-type(odd)': {
//       backgroundColor: theme.palette.action.hover,
//     },
//   },
// }))(TableRow);

// const useStyles = styled({
//   table: {
//     minWidth: 700,
//   },
// });

const MultiInputField = ({ id, name, type, typeName, order, label, required, options, input, meta, language }) => {

  const [checkedValues, setCheckedValues] = useState({});
  const [values, setValues] = useState({});
  const [labelHeader, setLabelHeader] = useState('');
  const [valueHeader, setValueHeader] = useState('');
  const [rows, setRows] = useState([]);

  // when component is already mount
  useEffect(() => {
    const arr = [];
    if (options.length > 0) {
      const defaultValues = {}
      const customValues = {}
      for (let option of options) {
        if (['OPTION', 'CUSTOM_OPTION'].includes(option.typeName)) {
          if (option.default) {
            defaultValues[option.id] = { ...option };
          }
          if (option.typeName === 'CUSTOM_OPTION') {
            customValues[option.id] = option.value;
            setValues(customValues);
          }
          arr.push({ ...option });
        }
      }
      setRows(arr);


      setCheckedValues(defaultValues);
      // Set default options
      if (Object.keys(defaultValues).length > 0) {
        input.onChange({
          id,
          typeName, //type,
          order,
          result: options.filter(option => defaultValues[option.id])
        });
      }
    }
  }, []);

  useEffect(() => {
    // console.log(language, options)
    if (options.length > 0) {
      for (let option of options) {
        if (option.typeName === 'OPTION_LABEL_HEADER') {
          // console.log(language, option)
          setLabelHeader(option.label);
        }
        if (option.typeName === 'OPTION_INPUT_HEADER') {
          // console.log(language, option)
          setValueHeader(option.label);
        }
      }
    }
  }, [language]);

  const handleChange = (event, option) => {
    const newValues = { ...checkedValues };
    newValues[option.id] = event.target.checked ? { ...option, value: values[option.id] } : null;
    // console.log('handleChange', event.target.checked, values, newValues, checkedValues);

    if (option.typeName === "CANCEL_OPTION") {
      Object.keys(newValues).forEach(key => {
        // FYI: key and option.id are different types, do not use "===", use ""=="
        if (!(key == option.id && event.target.checked)) {
          // console.log('option.id', option.id)
          delete newValues[key];
        }
      });
    } else {
      Object.keys(newValues).forEach(key => {
        if (newValues[key]?.typeName === "CANCEL_OPTION") {
          delete newValues[key];
        }
      });
    }

    setCheckedValues(newValues);
    // console.log('handleChange', event.target.checked, newValues, values, option, { ...option, ...{ value: values[option.id] } });

    if (Object.keys(newValues)?.filter(checkBox => !!newValues[checkBox])?.length > 0) {
      const result = options.map(op => {
        return {
          ...op,
          value: newValues[op.id]?.value
        };
      });

      // console.log('!result', result, result.filter(res => newValues[res.id]))

      input.onChange({
        id,
        typeName,
        order,
        result: result.filter(res => newValues[res.id])
      });
    } else {
      input.onChange(null);
    }
  }

  const handleCustomOptionChange = (event, option) => {
    const newValues = { ...checkedValues };
    newValues[option.id].value = event.target.value;
    const customValues = { ...values };
    setCheckedValues(newValues);

    // console.log('handleCustomOptionChange', event.target.value)

    if (Object.keys(newValues)?.filter(checkBox => !!newValues[checkBox])?.length > 0) {
      const result = options.map(op => {
        if (op.id === option.id) {
          return {
            ...op,
            value: event.target.value
          }
        }
        return {
          ...op,
          value: newValues[op.id]?.value
        };
      });

      // console.log('!result', result.filter(res => newValues[res.id]))

      if (option.typeName === 'CUSTOM_OPTION') {
        customValues[option.id] = newValues[option.id].value;
        setValues(customValues);
      }

      input.onChange({
        id,
        typeName,
        order,
        result: result.filter(res => newValues[res.id])
      });
    } else {
      input.onChange(null);
    }
  }

  // const classes = useStyles();
  const customColumnStyle = { maxWidth: "50px", backgroundColor: "green" };

  return (
    <div>
      {/* labelHeader: {JSON.stringify(labelHeader)}<br />
      valueHeader: {JSON.stringify(valueHeader)}<br /> */}
      <FormGroup>
        <TableContainer component={Paper}>
          <Table
            // className={classes.table} 
            aria-label="customized table">
            <TableHead>
              <TableRow>
                <TableCell align="center">{labelHeader}</TableCell>
                <TableCell align="center"></TableCell>
                <TableCell align="center">{valueHeader}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((option, index) => (
                <TableRow key={index}>
                  {/* <div key={index}> */}
                  <TableCell component="th" scope="row" width="40%">{option.label}</TableCell>
                  <TableCell align="right" width="1%" style={{ padding: '0' }}>{
                    <Checkbox
                      checked={!!checkedValues[option.id]}
                      onChange={(event) => handleChange(event, option)}
                      inputProps={{ 'aria-label': 'controlled' }}
                      style={{ width: '10%' }}
                    />
                  }</TableCell>
                  <TableCell align="right" width="90%">{
                    option.typeName === 'CUSTOM_OPTION' && // !!checkedValues[option.id] &&
                    <>
                      {/* <Checkbox
                        checked={!!checkedValues[option.id]}
                        onChange={(event) => handleChange(event, option)}
                        inputProps={{ 'aria-label': 'controlled' }}
                        style={{ width: '10%' }}
                      /> */}
                      <TextField
                        size="small"
                        fullWidth
                        value={values[option.id] || ""}
                        onChange={(e) => {
                          handleCustomOptionChange(e, option);
                        }}
                        disabled={!checkedValues[option.id]}
                        style={{ width: '100%' }}
                      />
                    </>
                  }
                  </TableCell>
                  {/* </div> */}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </FormGroup>
    </div>
  );
}

export default MultiInputField;